import { useState } from 'react';
import './NewsletterBanner.css';

export default function NewsletterBanner() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(event) {
    event.preventDefault();
    if (!email) return;

    setSubmitted(true);
    setEmail('');
  }

  return (
    <section className="newsletter-banner" aria-labelledby="newsletter-heading">
      <div className="header-container newsletter-banner__container">
        <div className="newsletter-banner__card">
          <div className="newsletter-banner__intro">
            <div>
              <h2 id="newsletter-heading">Join the Trillium Paws Family</h2>
              <p>Receive science-backed pet care guides, product launches, and 10% off your first purchase.</p>
            </div>
          </div>

          <form className="newsletter-banner__form" onSubmit={handleSubmit}>
            <label className="newsletter-banner__label" htmlFor="newsletter-email">Email address</label>
            <input
              id="newsletter-email"
              type="email"
              value={email}
              onChange={event => { setEmail(event.target.value); setSubmitted(false); }}
              placeholder="Enter your email address"
              required
            />
            <button type="submit">SUBSCRIBE</button>
            {submitted && <span className="newsletter-banner__success" role="status">Thanks for joining us.</span>}
          </form>
        </div>
      </div>
    </section>
  );
}
